const commonSk = {
    "restaurant": "Reštaurácia",
    "restaurant_not_found": "Reštaurácia nie je k dispozícii",
    "table_not_available": "Pri tomto stole nie je možné zadávať objednávky",
    "note": "Poznámka",
    "order": "Objednávka",
    "internal_error": "Požiadavka bola neúspešná. Server odpovedal nasledujúcou chybou:",
    "no_results": "Žiadne výsledky",
    "cancel": "Zrušiť",
    "save": "Uložiť",
    "back": "Späť",
    "search": "Hľadať",
    "search_for_file_names": "Vyhľadávanie názvov súborov",
    "delete": "Odstrániť",
    "search_by_restaurant": "Hľadať podľa reštaurácie",
    "available": "K dispozícii",
    "unavailable": "Nedostupné",
    "name": "Meno",
    "status": "Stav",
    "description": "Popis",
    "price": "Cena",
    "add": "Pridať",
    "phone": "Telefón",
    "internal_server_error": "Interná chyba servera",
    "remove_all": "Vymazať všetko",
    "settings": "Nastavenia",
    "restaurant_name": "Názov reštaurácie",
    "reservation_link": "Odkaz na rezerváciu",
    "reservation_link_tooltip": "Povolené sú iba odkazy na rezervačný systém Reservours",
    "add_user": "Pridať používateľa",
    "add_user_title": "Umožniť prístup do reštaurácie",
    "restaurant_users": "Používatelia s prístupom do reštaurácie",
    "restaurant_description_hu": "Popis reštaurácie (maďarská)",
    "restaurant_description_en": "Popis reštaurácie (anglicky)",
    "changes_saved": "Zmeny boli úspešne uložené",
    "user_added_to_restaurant": "Používateľovi bol udelený prístup do reštaurácie",
    "user_add_to_restaurant_tip": "Používateľ s poskytnutou e-mailovou adresou získa prístup do vybranej reštaurácie. Ak používateľ ešte nemá účet, prístup získa automaticky po registrácii.",
    "sign_up_here": "Účet si môžete vytvoriť tu",
    "role_already_exists": "Používateľ s týmto e-mailom už má prístup do reštaurácie",
    "error": "Chyba",
    "header_image": "Obrázok hlavičky",
    "upload_image": "Nahrať obrázok",
    "image_not_set": "Obrázok nie je nastavený",
    "validation": {
        "required": "Toto pole je povinné",
        "optional": "Toto pole je voliteľné"
    },
    "hungary": "Maďarsko",
    "date": "Dátum",
    "close": "Zatvoriť",
    "continue": "Pokračovať",
    "select_image": "Vybrať obrázok",
    "grant": "Grant",
    "restaurant_settings": "Prostredie reštaurácie",
    "create_restaurant": "Vytvoriť reštauráciu",
    "restaurant_created": "Reštaurácia bola úspešne vytvorená",
    "restaurant_created_text": "Vaša reštaurácia bola úspešne vytvorená. Teraz môžete pridávať položky do menu a spravovať nastavenia reštaurácie.",
    "continue_to_menu": "Pokračovať v úprave ponuky",
    "languages": {
        "hu": "maďarčina",
        "en": "Angličtina",
        "de": "Nemčina",
        "fr": "Francúzština",
        "sk": "Slovák",
        "cz": "čeština",
        "pl": "poľština",
        "si": "slovinčina",
        "hr": "Chorvátčina",
        "ro": "Rumunčina"
    },
    "no_file_selected": "Nie je vybraný žiadny súbor",
    "max_file_size": "Maximálna veľkosť súboru:",
    "language": "Jazyk",
    "google_analytics": "Google Analytics",
    "facebook_pixel": "Facebook Pixel",
    "analytic_integration_premium_feature": "Integrácia analytických nástrojov je súčasťou plánu PRO",
    "refresh": "Obnoviť",
    "address": "Adresa",
    "city": "Mesto",
    "postal_code": "Poštové smerovacie číslo",
    "timezone": "Časové pásmo",
    "country": "Krajina",
    "currency": "Mena",
    "currency_tooltip": "Toto je potrebné iba pre nastavenia profilu, náš systém nebude vykonávať finančné transakcie za vás.",
    "or": "alebo"
};

export default commonSk;
